<template>

    <div class="main-container">
        <!-- Background Image Grid -->
        <div class="image-grid">
            <div class="image-column">
                <img v-no-right-click src="https://dummyimage.com/300x400/e83e8c/e83e8c" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/20c997/20c997" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-md-block">
                <img v-no-right-click src="https://dummyimage.com/300x350/6f42c1/6f42c1" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x400/dc3545/dc3545" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-lg-block">
                <img v-no-right-click src="https://dummyimage.com/300x400/007bff/007bff" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/6610f2/6610f2" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/17a2b8/17a2b8" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x350/17a2b8/17a2b8" alt="Grid Image"> 
            </div>
            <div class="image-column">
                <img v-no-right-click src="https://dummyimage.com/300x400/e83e8c/e83e8c" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/20c997/20c997" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-md-block">
                <img v-no-right-click src="https://dummyimage.com/300x350/6f42c1/6f42c1" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x400/dc3545/dc3545" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-lg-block">
                <img v-no-right-click src="https://dummyimage.com/300x400/007bff/007bff" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/6610f2/6610f2" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/17a2b8/17a2b8" alt="Grid Image">  
                <img v-no-right-click src="https://dummyimage.com/300x350/17a2b8/17a2b8" alt="Grid Image">  
            </div> 
            <div class="image-column">
                <img v-no-right-click src="https://dummyimage.com/300x400/e83e8c/e83e8c" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/20c997/20c997" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-md-block">
                <img v-no-right-click src="https://dummyimage.com/300x350/6f42c1/6f42c1" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x400/dc3545/dc3545" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
            </div> 
        </div>

        <!-- Login Form Container -->
        <div class="login-container">
            <div class="login-box">
                <div class="text-center mb-4">
                    <img v-no-right-click src="/assets/logo-icon.png" style="height:55px" alt="Logo" class="logo rounded">
                    <h2 class="welcome-text">Forgot Your Password ?</h2>
                </div>  

                <form @submit.prevent="handleForgotPassword" autocomplete="none">
                    <div class="form-group">
                        <input type="text" v-model="form.email" class="form-control" placeholder="Email ID">
                    </div> 
                    <button type="submit" class="btn btn-pinterest btn-block">Submit</button>
                    <div class="row py-3">
                        <div class="col-6"></div>
                        <div class="col-6 text-right"><router-link to="/login" class="signup-link"><i class="fas fa-arrow-left mr-2"></i>Back to Login</router-link></div>
                    </div>

                </form> 
            </div>
        </div>

        <div v-if="isResetModalOpen" class="reset-modal-overlay">
            <div class="reset-modal">
                <button class="close-btn" type="button" @click="closeResetModal">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h3 class="modal-title text-center mb-2">Reset Password</h3>
                <p class="text-muted text-center mb-4">Enter the OTP sent to <strong>{{ resetForm.email }}</strong> and set your new password.</p>

                <form @submit.prevent="handleResetSubmit" autocomplete="off">
                    <input type="hidden" :value="resetForm.email">

                    <div class="form-group">
                        <label class="form-label">OTP</label>
                        <input type="text" v-model="resetForm.otp" class="form-control" placeholder="Enter OTP" autocomplete="one-time-code">
                    </div>

                    <div class="form-group">
                        <label class="form-label">New Password</label>
                        <div class="password-input-wrapper has-generator">
                            <input
                                :type="passwordVisibility.password ? 'text' : 'password'"
                                v-model="resetForm.password"
                                class="form-control"
                                placeholder="New Password"
                                autocomplete="new-password"
                            >
                            <div class="password-actions">
                                <button type="button" class="password-action" @click="togglePasswordVisibility('password')" aria-label="Toggle password visibility">
                                    <i :class="passwordVisibility.password ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                                </button>
                                <button type="button" class="password-action generate" @click="handleGeneratePassword">
                                    Generate
                                </button>
                            </div>
                        </div>

                        <div class="strength-meter mt-2" aria-hidden="true">
                            <div
                                class="meter-bar"
                                :class="passwordStrengthClass"
                                :style="{ width: passwordStrengthPercent + '%' }"
                            ></div>
                        </div>
                        <div class="strength-label">{{ passwordStrengthLabel }}</div>

                        <ul class="password-rules">
                            <li :class="{ passed: passwordChecks.hasUpper }">At least one uppercase letter</li>
                            <li :class="{ passed: passwordChecks.hasLower }">At least one lowercase letter</li>
                            <li :class="{ passed: passwordChecks.hasNumber }">At least one number</li>
                            <li :class="{ passed: passwordChecks.hasSpecial }">At least one special character</li>
                            <li :class="{ passed: passwordChecks.hasLength }">Minimum 8 characters</li>
                        </ul>
                    </div>

                    <div class="form-group">
                        <label class="form-label">Confirm Password</label>
                        <div class="password-input-wrapper">
                            <input
                                :type="passwordVisibility.confirmPassword ? 'text' : 'password'"
                                v-model="resetForm.confirmPassword"
                                class="form-control"
                                placeholder="Confirm Password"
                                autocomplete="new-password"
                            >
                            <div class="password-actions">
                                <button type="button" class="password-action" @click="togglePasswordVisibility('confirmPassword')" aria-label="Toggle confirm password visibility">
                                    <i :class="passwordVisibility.confirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <button type="submit" class="btn btn-pinterest btn-block mt-3" :disabled="isResetSubmitting">
                        {{ isResetSubmitting ? 'Updating...' : 'Update Password' }}
                    </button>
                </form>
            </div>
        </div>
    </div> 
 </template>
<script setup>
import { reactive, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import Swal from 'sweetalert2' 
import api from '@/services/api'
import { useHead } from '@vueuse/head'

useHead({
  title: 'Invi8 - User Forgot Password',
  meta: [
    { name: 'description', content: 'Forgot password page for Invi8' },
    { name: 'keywords', content: 'forgot password, reset, vue 3' },
  ],
})

const router = useRouter() 

const form = reactive({
  email: ''
})

const resetForm = reactive({
  email: '',
  otp: '',
  password: '',
  confirmPassword: ''
})

const isResetModalOpen = ref(false)
const isResetSubmitting = ref(false)
const passwordVisibility = reactive({
  password: false,
  confirmPassword: false
})

const passwordChecks = computed(() => {
  const value = resetForm.password || ''
  return {
    hasUpper: /[A-Z]/.test(value),
    hasLower: /[a-z]/.test(value),
    hasNumber: /\d/.test(value),
    hasSpecial: /[^A-Za-z0-9]/.test(value),
    hasLength: value.length >= 8,
  }
})

const passwordStrength = computed(() => Object.values(passwordChecks.value).filter(Boolean).length)
const passwordStrengthPercent = computed(() => (passwordStrength.value / 5) * 100)

const passwordStrengthLabel = computed(() => {
  if (!resetForm.password) return 'Strength: Empty'
  if (passwordStrength.value <= 2) return 'Strength: Weak'
  if (passwordStrength.value <= 4) return 'Strength: Medium'
  return 'Strength: Strong'
})

const passwordStrengthClass = computed(() => {
  if (passwordStrength.value <= 2) return 'weak'
  if (passwordStrength.value <= 4) return 'medium'
  return 'strong'
})

const passwordRequirementsMet = computed(() => Object.values(passwordChecks.value).every(Boolean))

const togglePasswordVisibility = (field) => {
  passwordVisibility[field] = !passwordVisibility[field]
}

const generateSecurePassword = () => {
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const lowercase = 'abcdefghijklmnopqrstuvwxyz'
  const numbers = '0123456789'
  const special = '!@#$%^&*()_+-=[]{}|;:,.<>?'
  const allChars = uppercase + lowercase + numbers + special

  const randomChar = (chars) => chars[Math.floor(Math.random() * chars.length)]

  const passwordArray = [
    randomChar(uppercase),
    randomChar(lowercase),
    randomChar(numbers),
    randomChar(special),
  ]

  while (passwordArray.length < 8) {
    passwordArray.push(randomChar(allChars))
  }

  for (let i = passwordArray.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1))
    const temp = passwordArray[i]
    passwordArray[i] = passwordArray[j]
    passwordArray[j] = temp
  }

  return passwordArray.join('')
}

const handleGeneratePassword = () => {
  const generated = generateSecurePassword()
  resetForm.password = generated
  resetForm.confirmPassword = generated
}

const openResetModal = (email) => {
  resetForm.email = email
  resetForm.otp = ''
  resetForm.password = ''
  resetForm.confirmPassword = ''
  isResetModalOpen.value = true
}

const closeResetModal = () => {
  if (!isResetSubmitting.value) {
    isResetModalOpen.value = false
  }
}

const handleForgotPassword = async () => {
  const email = (form.email || '').trim().toLowerCase()
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i

  if (!email) {
    Swal.fire('Error', 'Email ID is required.', 'error')
    return
  }

  if (!emailRegex.test(email)) {
    Swal.fire('Error', 'Please enter a valid email address.', 'error')
    return
  }

  try {
    const formData = new FormData()
    formData.append('email', email)

    const { data } = await api.loginResetApi(formData)

    if (data.status === 'ok') {
      Swal.fire({
        title: 'Success',
        text: data.message || 'Enter the OTP sent to your email.',
        icon: 'success',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      })
      openResetModal(email)
    } else {
      Swal.fire('Error', data.message || 'Invalid request.', 'error')
    }
  } catch (err) {
    console.error('Error:', err)
    Swal.fire('Server Error', 'Something went wrong.', 'error')
  }
}

const handleResetSubmit = async () => {
  const otp = (resetForm.otp || '').trim()

  if (!otp) {
    Swal.fire('Error', 'OTP is required.', 'error')
    return
  }

  if (!passwordRequirementsMet.value) {
    Swal.fire('Error', 'Password must include uppercase, lowercase, number, special character and be at least 8 characters.', 'error')
    return
  }

  if (!resetForm.confirmPassword) {
    Swal.fire('Error', 'Please confirm your password.', 'error')
    return
  }

  if (resetForm.password !== resetForm.confirmPassword) {
    Swal.fire('Error', 'Passwords do not match.', 'error')
    return
  }

  try {
    isResetSubmitting.value = true
    const formData = new FormData()
    formData.append('email', resetForm.email)
    formData.append('otp', otp)
    formData.append('password', resetForm.password)
    formData.append('confirm_password', resetForm.confirmPassword)

    const { data } = await api.loginResetVerifyApi(formData)

    if (data.status === 'ok') {
      Swal.fire('Success', data.message || 'Password updated successfully.', 'success')
      isResetModalOpen.value = false
      router.push('/login')
    } else {
      Swal.fire('Error', data.message || 'Unable to update password.', 'error')
    }
  } catch (err) {
    console.error('Error:', err)
    Swal.fire('Server Error', 'Something went wrong.', 'error')
  } finally {
    isResetSubmitting.value = false
  }
}
</script>


<style>
/* Main Container */
.main-container {
    min-height: 100%;
    display: flex;
    position: relative;
    overflow: hidden;
}

/* Image Grid Styles */
.image-grid {
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    opacity: 1;
    z-index: -1;
}

.image-column {
    flex: 1;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.image-column img {
    width: 100%;
    border-radius: 16px;
    object-fit: cover;
    margin-bottom: 20px;
}

/* Login Container Styles */
.login-container {
    width: 100%;
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 100px 0px;
    background: rgba(255, 255, 255, 0.9);
}

.login-box {
    background: white;
    padding: 30px;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
}

/* Logo and Welcome Text */
.logo {
    border-radius: 50%;
    margin-bottom: 10px;
}

.welcome-text {
    font-size: 32px;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
}

/* Form Elements */
.form-control {
    border-radius: 16px;
    padding: 12px 16px;
    font-size: 16px;
    border: 2px solid #efefef;
}

.form-control:focus {
    border-color: #FB7210;
    box-shadow: none;
}

.forgot-password {
    color: #FB7210;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
}

.forgot-password:hover {
    color: #333;
    text-decoration: none;
}

.signup-link {
    color: #FB7210;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
}

.signup-link:hover {
    color: #333;
    text-decoration: none;
}

/* Buttons */
.btn {
    border-radius: 20px;
    padding: 12px 16px;
    font-weight: 600;
    font-size: 15px;
}

.btn-pinterest {
    background-color: #FB7210;
    color: white;
    border: none;
}

.btn-pinterest:hover {
    background-color: #ad081b;
    color: white;
}

.btn-facebook {
    background-color: #1877f2;
    color: white;
    border: none;
}

.btn-facebook:hover {
    background-color: #0d65d9;
    color: white;
}

.btn-google {
    background-color: white;
    color: #333;
    border: 2px solid #efefef;
}

.btn-google:hover {
    background-color: #f8f8f8;
}

/* Divider */
.divider {
    text-align: center;
    margin: 20px 0;
    position: relative;
}

.divider::before,
.divider::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 45%;
    height: 1px;
    background-color: #efefef;
}

.divider::before {
    left: 0;
}

.divider::after {
    right: 0;
}

.divider span {
    background-color: white;
    padding: 0 10px;
    color: #666;
    font-size: 14px;
}

/* Business Text */
.business-text {
    color: #666;
    font-size: 12px;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
    .login-box {
        padding: 20px;
    }
    
    .welcome-text {
        font-size: 24px;
    }
    
    .image-grid {
        opacity: 0.2;
    }
}

@media (max-width: 576px) {
    .login-container {
        padding: 10px;
    }
    
    .login-box {
        box-shadow: none;
    }
    
    .image-grid {
        opacity: 0.1;
    }
}

.reset-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    z-index: 1050;
}

.reset-modal {
    background: #fff;
    width: 100%;
    max-width: 500px;
    border-radius: 16px;
    padding: 30px;
    position: relative;
    box-shadow: 0 15px 45px rgba(0, 0, 0, 0.2);
}

.reset-modal .close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    border: none;
    background: transparent;
    font-size: 28px;
    color: #777;
    cursor: pointer;
}

.password-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.password-input-wrapper .form-control {
    padding-right: 70px;
}

.password-input-wrapper.has-generator .form-control {
    padding-right: 190px;
}

.password-actions {
    position: absolute;
    right: 15px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.password-action {
    border: none;
    background: transparent;
    color: #FB7210;
    cursor: pointer;
    font-weight: 600;
}

.password-action i {
    font-size: 18px;
}

.password-action.generate {
    padding: 6px 12px;
    border-radius: 12px;
    background: rgba(251, 114, 16, 0.1);
    font-size: 13px;
    color: #FB7210;
}

.strength-meter {
    width: 100%;
    height: 6px;
    background: #f1f1f1;
    border-radius: 999px;
    overflow: hidden;
}

.meter-bar {
    height: 100%;
    width: 0;
    border-radius: inherit;
    transition: width 0.3s ease;
}

.meter-bar.weak {
    background: #dc3545;
}

.meter-bar.medium {
    background: #ffc107;
}

.meter-bar.strong {
    background: #28a745;
}

.strength-label {
    font-size: 13px;
    margin-top: 6px;
    color: #555;
}

.password-rules {
    list-style: none;
    padding-left: 0;
    margin-top: 12px;
    font-size: 13px;
    color: #777;
}

.password-rules li {
    position: relative;
    padding-left: 18px;
    margin-bottom: 4px;
}

.password-rules li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #FB7210;
}

.password-rules li.passed {
    color: #28a745;
}

.password-rules li.passed::before {
    content: '✓';
}
</style>
